import {Component, OnDestroy, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HelperService} from '../../shared/services/helper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ApiService} from '../../api/api.service';
import {AuthService} from "../../core/services/auth.service";
import {Subscription} from "rxjs";
import {AppLocaleService} from "../../core/services/locale.service";

@Component({
  selector: 'app-integrated-login',
  templateUrl: './integrated-login.component.html',
  styleUrls: ['./integrated-login.component.scss']
})
export class IntegratedLoginComponent implements OnInit, OnDestroy {

  subscriptions: Subscription = new Subscription();
  subDomain = null;

  constructor(protected helper: HelperService,
              private router: Router,
              public _api: ApiService,
              private _translate: TranslateService,
              private activatedRoute: ActivatedRoute,
              public authService: AuthService,
              private _localeService: AppLocaleService) {
    this.subDomain = window.location.hostname.replace(environment.domain, '').replace('.', '').toLowerCase();

    this.activatedRoute.queryParamMap.subscribe(params => {
      const url = params.get('url');
      sessionStorage.setItem('url', url);

      this.autoLogin();
    });
  }

  ngOnInit(): void {
    if (null == this.helper.getUser() || !this.helper.getUser().id) {
      this.activatedRoute.queryParamMap.subscribe(params => {
        const code = params.get('code');

        if (code) {
          this._api.Integration.integratedLogin(code, '').subscribe((date) => {
            this.authService.trySetSession(date.email, date.access_token, date.token_type, date.refresh_token, date.scope, date.aki, date.sak, date.st);
            this.getUserDetails();
          }, (err: any) => {
            this.router.navigate(['/login']);
          })
        } else {
          this.autoLogin();
        }
      });
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getUserDetails(): void {
    this.subscriptions.add(this._api.User.self().subscribe((user) => {
      this.helper.setUser(user);
      this._translate.setDefaultLang(user.interfaceLanguageCode);
      this._translate.use(user.interfaceLanguageCode);
      this._translate.reloadLang(user.interfaceLanguageCode);
      this._localeService.setLocale(user.interfaceLanguageCode);
      this.authService.clearOldSession();
      const url = sessionStorage.getItem('url');

      if (url) {
        this.router.navigate([url]).then(() => {
          sessionStorage.removeItem('url')
        })
      } else {
        if (user.roles.indexOf('ROLE_SUPERADMIN') > -1) {
          this.router.navigate(['app/superadmin/clients']);
        } else if (user.roles.indexOf('ROLE_SYSTEMADMIN') > -1 && user.accessLevels.length) {
          this.router.navigate(['app/welcome-sys-admin']);
        } else if (user.roles.indexOf('ROLE_SYSTEMADMIN') > -1 && !user.accessLevels.length) {
          this.router.navigate(['app/no-permission-sys-admin']);
        } else {
          this.router.navigate([this.helper.getHomePageUrl()]);
        }
      }

    }, (err) => {
      if (err.error && err.error.error === 'access_denied' && err.error.error_description === 'User account is disabled') {
        $('.account-disabled').slideDown(200);
      }
    }));
  }

  autoLogin() {
    if (this.helper.getUser() && this.helper.getUser().id) {
      if (this.helper.isSuperAdmin()) {
        this.router.navigate(['app/superadmin/clients']);
      } else if (this.helper.isSysAdmin() && this.helper.getUser().accessLevels.length) {
        this.router.navigate(['app/welcome-sys-admin']);
      } else if (this.helper.isSysAdmin() && !this.helper.getUser().accessLevels.length) {
        this.router.navigate(['app/no-permission-sys-admin']);
      } else {
        this.router.navigate([this.helper.getHomePageUrl()]);
      }
    }
  }

}
